import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5fd47d0c"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppHeader: require('/www/wwwroot/pc.hankahuanbao.com/components/app-header.vue').default,AppFooter: require('/www/wwwroot/pc.hankahuanbao.com/components/app-footer.vue').default})
